import React, { Fragment } from "react";

// Images
import img13 from "../../../images/service/DeFi/1.png";
import img14 from "../../../images/service/DeFi/2.png";

// SERVICE ICON SERIES (USE EVERYWHERE)
import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";

// Layout Components
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

// Page Sections
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import HeroSection from "../../../components/PageSection/HeroSection";
import TheorySection from "../../../components/PageSection/Theory";


// ---------------------------
// DATA
// ---------------------------

const serviceCards = [
  {
    icon: sIcon1,
    title: "DeFi Platform Development",
    content:
      "Custom decentralized finance platforms built for security, scalability, and future-ready innovation.",
  },
  {
    icon: sIcon2,
    title: "DeFi Smart Contract Engineering",
    content:
      "Smart contracts that automate financial logic and eliminate middlemen for transparent operations.",
  },
  {
    icon: sIcon3,
    title: "DeFi Wallet & Custody Solutions",
    content:
      "Secure, user-friendly DeFi wallet systems that give users full control of their digital assets.",
  },
  {
    icon: sIcon4,
    title: "Borrowing & Lending Protocols",
    content:
      "Robust DeFi borrowing and lending frameworks with decentralized interest models and liquidity pools.",
  },
];

const benefits = [
  {
    title: "Financial Inclusion",
    description:
      "Our DeFi solutions enable global access to financial services without centralized institutions or restrictions.",
    icon: sIcon1,
  },
  {
    title: "Automated Trust",
    description:
      "Smart contracts ensure transparent, tamper-proof execution of financial logic without intermediaries.",
    icon: sIcon2,
  },
  {
    title: "Enhanced Transparency",
    description:
      "Every transaction is recorded on-chain, providing immutable audit trails and full visibility.",
    icon: sIcon3,
  },
];

const keyFeatures = [
  {
    icon: sIcon1,
    title: "Permissionless Access",
    description:
      "Users can interact with DeFi protocols globally without approvals or centralized control.",
  },
  {
    icon: sIcon2,
    title: "Yield Farming & Liquidity Pools",
    description:
      "Advanced yield optimization strategies and automated market makers (AMMs).",
  },
  {
    icon: sIcon3,
    title: "Decentralized Exchanges (DEX)",
    description:
      "Peer-to-peer trading infrastructure with no custody or central authority.",
  },
  {
    icon: sIcon4,
    title: "Stablecoin Integration",
    description:
      "Support for stable digital assets to reduce volatility across DeFi platforms.",
  },
  {
    icon: sIcon1,
    title: "Governance Tokens",
    description:
      "Community-driven governance allowing token holders to vote on protocol decisions.",
  },
  {
    icon: sIcon2,
    title: "Cross-Chain Interoperability",
    description:
      "Seamless interaction between multiple blockchains to expand liquidity access.",
  },
];

const faqs = [
  {
    q: "What is Decentralized Finance (DeFi)?",
    a: "DeFi refers to blockchain-based financial systems that operate without intermediaries, using smart contracts for transparent and automated transactions.",
  },
  {
    q: "Why should my business adopt DeFi solutions?",
    a: "DeFi enables global reach, reduces operational costs, improves transparency, and gives users complete asset control.",
  },
  {
    q: "What DeFi solutions can you develop?",
    a: "We develop DeFi platforms, DEXs, wallets, lending & borrowing protocols, yield farming systems, and governance models.",
  },
  {
    q: "How secure are DeFi applications?",
    a: "We follow industry-best security practices including smart contract audits, secure key handling, and protocol testing.",
  },
  {
    q: "Can DeFi integrate with existing systems?",
    a: "Yes, DeFi protocols can integrate with traditional systems using APIs, blockchain bridges, and middleware.",
  },
];

// ---------------------------
// PAGE
// ---------------------------

export default function DeFiDevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Decentralized Finance (DeFi) Development Services"
        pagesub="Empowering the Future of Open Finance"
      />

      <HeroSection
  title={
    <>
      Boost Your NFT Project with{" "}
      <span className="gradient-text">Strategic NFT Marketing</span>
    </>
  }
  subtitle={`Tokenize all your collectibles with smart and unique NFT Development Services.
As an expert NFT development company, Shamla Tech provides cutting-edge NFT development services for all your business needs.`}
  buttonText="Book Consultation"
  buttonLink="/contact"
  image={img13}
  imageAlt="NFT Marketing Banner"
/>




<TheorySection
  title="Understanding the Evolution of NFTs"
  image={img14}
  paragraphs={[
    "Non-Fungible Tokens (NFTs) represent a paradigm shift in digital ownership. Unlike traditional cryptocurrencies, NFTs are unique cryptographic assets recorded on a blockchain, making them indivisible, verifiable, and provably scarce. This allows NFTs to represent digital art, collectibles, gaming assets, intellectual property, and even real-world assets with transparent ownership and authenticity.",

    "NFTs are powered by smart contracts that automate ownership transfers, enforce royalty distribution, and validate provenance without intermediaries. This programmable foundation unlocks new economic models for creators, brands, and enterprises — fostering direct engagement, community ownership, and decentralized marketplaces. As Web3 adoption grows, NFTs are becoming core pillars of decentralized digital economies worldwide.",
  ]}
/>



      <ServiceCardsSection title="Our DeFi Development Services" cards={serviceCards} />
      <Benefit title="Benefits of DeFi for Your Business" benefits={benefits} />
      <KeyFeaturesSection
        title="Key Features of Our DeFi Solutions"
        subtitle="Built for performance, security, and global scale."
        features={keyFeatures}
      />
      <WhyChooseUsSection
        items={[
          "End-to-end DeFi development expertise",
          "Battle-tested blockchain engineers",
          "Security-first development approach",
        ]}
      />
      <FaqSection faqs={faqs} />
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
